import { Button, Flex, Input, Modal, Text } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { useDisclosure } from "@mantine/hooks";
import { IconTransform } from "@tabler/icons-react";
import convert, { type Angle } from "convert";
import { useEffect, useState } from "react";

import useTriggerInlineSave from "../../hooks/useTriggerInlineSave";
import { useDispatch, useSelector } from "../../redux/hooks";
import { setEditing } from "../../redux/slices/entrySlice";
import { setUnitConverterModalData } from "../../redux/slices/generatorFeaturesSlice";

const UnitConverterModal = () => {
  const dispatch = useDispatch();
  const [opened, { open, close }] = useDisclosure(false);
  const { unitConverterModalData: data } = useSelector(
    state => state.generatorFeaturesSlice,
  );
  const triggerSave = useTriggerInlineSave(data?.sectionIndex);

  const [fromValue, setFromValue] = useState<number>();
  const [convertFromUnit, setConvertFromUnit] = useState<any>(
    data?.unit || data?.selectOptionsData[0].value,
  );
  const [convertToUnit, setConvertToUnit] = useState<any>(
    data?.unit || data?.selectOptionsData[0].value,
  );

  useEffect(() => {
    if (data) {
      setFromValue(parseFloat(data?.value));
      setConvertFromUnit(data?.unit || data?.selectOptionsData[0].value);
      setConvertToUnit(data?.unit || data?.selectOptionsData[0].value);
      open();
    }
  }, [data]);
  const handleClose = () => {
    dispatch(setUnitConverterModalData(null));
    close();
  };
  const handleFromChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const numericValue = parseFloat(inputValue);
    setFromValue(numericValue);
  };

  const handleSubmit = () => {
    if (fromValue) {
      triggerSave();
      dispatch(setEditing(true));

      data?.onChange({
        value: parseFloat(
          Number(convert(fromValue, convertFromUnit).to(convertToUnit)).toFixed(
            5,
          ),
        ),
        unit: convertToUnit,
      });
    }
    handleClose();
  };

  return (
    <Modal
      zIndex={11}
      title={data?.converterName}
      opened={opened}
      onClose={handleClose}>
      <Flex align="center">
        <Text>From:</Text>
        <Flex w={"100%"} justify={"end"}>
          <Input
            type="number"
            value={fromValue}
            onChange={handleFromChange}
            mr={15}
            aria-label="fromInput"></Input>
          <Select
            withinPortal
            value={convertFromUnit}
            onChange={newValue => setConvertFromUnit(newValue as Angle)}
            w={130}
            placeholder="Unit"
            data={data?.selectOptionsData ?? []}
          />
        </Flex>
      </Flex>
      <Flex align="center" mt={15}>
        <Text>To:</Text>
        <Flex w={"100%"} justify={"end"}>
          <Input
            readOnly={true}
            type="number"
            value={
              fromValue
                ? Number(
                    Number(
                      convert(fromValue, convertFromUnit).to(convertToUnit),
                    ).toFixed(5),
                  )
                : ""
            }
            mr={15}></Input>
          <Select
            withinPortal
            value={convertToUnit}
            onChange={newValue => setConvertToUnit(newValue as Angle)}
            w={130}
            placeholder="Unit"
            data={data?.selectOptionsData ?? []}
          />
        </Flex>
      </Flex>
      <Flex justify="end" mt={15}>
        <Button
          onClick={handleSubmit}
          size="xs"
          leftSection={<IconTransform size={"1rem"} />}
          mr={5}>
          Done
        </Button>
      </Flex>
    </Modal>
  );
};
export default UnitConverterModal;
